export const initialState = {
  enroll: false,
  enrollSuccess: false,
  enrollError: null,

  unEnroll: false,
  unEnrollSuccess: false,
  unEnrollError: null,

  fetch: false,
  fetchSuccess: false,
  fetchError: null,

  askExpert: false,
  askExpertSuccess: false,
  askExpertError: null,

  createPdf: false,
  createPdfSuccess: false,
  createPdfError: null,

  model: null
};

export default function reducer(
  state = {
    ...initialState
  },
  action
) {
  switch (action.type) {
    case "MODULE_SET":
      return {
        ...initialState,
        model: action.data,
      };

    case "MODULE_ENROLL":
      return {
        ...state,
        enroll: true,
        enrollSuccess: false,
        enrollError: null,

        model: action.data,
      };

    case "MODULE_ENROLL_FULFILLED":
      return {
        ...state,
        enroll: false,
        enrollSuccess: true,

        model: action.data,
      };

    case "MODULE_ENROLL_REJECTED":
      return {
        ...state,
        enroll: false,
        enrollSuccess: false,
        enrollError: action.data,
      };

    case "MODULE_UNENROLL":
      return {
        ...state,
        unEnroll: true,
        unEnrollSuccess: false,
        unEnrollError: null,

        model: action.data,
      };

    case "MODULE_UNENROLL_FULFILLED":
      return {
        ...state,
        unEnroll: false,
        unEnrollSuccess: true,
        enrollSuccess: false,

        model: action.data,
      };

    case "MODULE_UNENROLL_REJECTED":
      return {
        ...state,
        unEnroll: false,
        unEnrollSuccess: false,
        unEnrollError: action.data,
      };

    case "MODULE_FETCH":
      return {
        ...state,
        fetch: true,
        fetchSuccess: false,
        fetchError: null,

        model: action.data,
      };

    case "MODULE_FETCH_FULFILLED":
      return {
        ...state,
        fetch: false,
        fetchSuccess: true,

        model: action.data,
      };

    case "MODULE_FETCH_REJECTED":
      return {
        ...state,
        fetch: false,
        fetchSuccess: false,
        fetchError: action.data,
      };

    case "ACTIVITY_COMPLETE_FULFILLED":
      return {
        ...state,
        model: state.model !== null && state.model.sequence === action.data.module_sequence
          ? {
            ...state.model,
            lessons: state.model.lessons.map(lesson => {
              if (lesson.activities) {
                return {
                  ...lesson,
                  activities: lesson.activities.map(activity => {
                    return activity.id === action.data.id ? action.data : activity;
                  })
                };
              }
              return lesson;
            })
          }
          : state.model
      };

    case "ASK_EXPERT":
      return {
        ...state,
        askExpert: true,
        askExpertSuccess: false,
        askExpertError: null,
      };

    case "ASK_EXPERT_FULFILLED":
      return {
        ...state,
        askExpert: false,
        askExpertSuccess: true,
      };

    case "ASK_EXPERT_REJECTED":
      return {
        ...state,
        askExpert: false,
        askExpertSuccess: false,
        askExpertError: action.data,
      };

    case "MODULE_CERTIFICATE_PDF":
      return {
        ...state,
        createPdf: true,
        createPdfSuccess: false,
        createPdfError: null,

        model: action.data,
      };

    case "MODULE_CERTIFICATE_PDF_FULFILLED":
      return {
        ...state,
        createPdf: false,
        createPdfSuccess: true,
      };

    case "MODULE_CERTIFICATE_PDF_REJECTED":
      return {
        ...state,
        createPdf: false,
        createPdfSuccess: false,
        createPdfError: action.data,
      };

    case "LOGOUT":
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
